import React from 'react';
import './brand-logo.css';

const BrandLogo = ({
  variant = 'light',
  showTagline = false,
  className = '',
}) => {
  const isDark = variant === 'dark';
  const word = isDark ? '#FFFFFF' : '#10273F';
  const nine = isDark ? '#0F8F5E' : '#10273F';
  const tag = isDark ? 'rgba(242, 245, 248, 0.78)' : '#0F8F5E';
  const markBg = isDark ? '#FFFFFF' : '#10273F';
  const card = isDark ? '#10273F' : '#FFFFFF';

  return (
    <span className={`c99-logo ${isDark ? 'c99-logo--dark' : ''} ${className}`.trim()}>
      <svg className="c99-logo-mark" viewBox="0 0 64 64" aria-hidden="true">
        <rect width="64" height="64" rx="16" fill={markBg} />
        <rect x="11" y="17" width="42" height="30" rx="6" fill={card} />
        <rect x="11" y="17" width="42" height="4.5" fill="#C99A3F" />
        <polyline
          points="18,38 27,32 35,35 44,24"
          fill="none"
          stroke="#0F8F5E"
          strokeWidth="2.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.6 22.2 L46.4 21.4 L44.2 26.8"
          fill="none"
          stroke="#0F8F5E"
          strokeWidth="2.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="c99-logo-copy">
        <span className="c99-logo-word">
          <span style={{ color: word }}>credit</span>
          <span style={{ color: nine }}>99</span>
        </span>
        {showTagline && (
          <span className="c99-logo-tagline" style={{ color: tag }}>
            salary ka backup plann.
          </span>
        )}
      </span>
    </span>
  );
};

export default BrandLogo;
